<template>

    <form id="visit-form" action="/visit/send" method="POST" class="grid lg:grid-cols-2 gap-y-10 sm:gap-y-10 2xl:gap-y-10 gap-x-10 xl:gap-x-12 2xl:gap-x-14 lg:mb-10">

        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="visit" :value="form.visit">
        <input type="hidden" name="tryme" :value="validator">
        <input type="hidden" name="lang" :value="lang">

        <span class="relative w-full block col-span-2 lg:col-span-2">
            <span class="w-full flex flex-col relative text-black">
                <input @focus="validation.fullname.state = null" name="name" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="form.fullname" />
                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{$root.translateString('name')}}*</label>
            </span>
            <span v-if="validation.fullname.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.fullname.message }}
            </span>
        </span>

        <span class="relative w-full block col-span-2 lg:col-span-1">
            <span class="w-full flex flex-col relative text-black">
                <input @focus="validation.email.state = null" name="email" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="email" v-model="form.email" />
                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">E-mail*</label>
            </span>
            <span v-if="validation.email.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.email.message }}
            </span>
        </span>

        <span class="relative w-full block col-span-2 lg:col-span-1">
            <span class="w-full flex flex-col relative text-black">
                <input @focus="validation.phone.state = null" name="phone" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="tel" v-model="form.phone" />
                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{$root.translateString('phone')}}*</label>
            </span>
            <span v-if="validation.phone.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.phone.message }}
            </span>
        </span>

        <!-- <span class="relative w-full block col-span-2 lg:col-span-1">
            <span class="w-full flex flex-col relative text-black">
                <div class="w-full">
                    <date-picker name="birthdate" :input-attr="{readonly: true, name: 'birth_date'}" :disabledDate="disabledDateBirthDate" :append-to-body="false" v-model="form.birth_date" :format="'DD/MM/YYYY'" valueType="format" @focus="validation.birth_date.state = null, showPlaceholderBirthDate = ''" :input-class="'pb-2 w-full px-3 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer'"></date-picker>
                    <label class="text-black absolute pointer-events-none text-sm xl:text-xbase top-0 transition-all w-full text-left" :class="!showPlaceholderBirthDate && '!text-xs !-top-5.5'"> {{$root.translateString('birth-date')}} *</label>
                </div>
            </span>
            <span v-if="validation.birth_date.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.birth_date.message }}
            </span>
        </span> -->

        <span class="relative w-full block col-span-2 lg:col-span-1">
            <span class="w-full flex flex-col relative text-black">
                <div class="w-full inline-flex">
                    <date-picker :input-attr="{readonly: true}" name="date" :disabledDate="disabledDate" :append-to-body="false" v-model="form.date" :format="'DD/MM/YYYY'" valueType="format" @focus="validation.date.state = null, showPlaceholderDate = false" @blur="handleBlur" :input-class="'inline-flex h-7 pt-0 pb-4 w-full pl-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer'"></date-picker>
                    <label class="text-black absolute text-xs sm:text-sm xl:text-xs -top-0.5 left-0 pointer-events-none  transition-all w-full text-left" :class="!showPlaceholderDate && '!text-xxs sm:!text-xs xl:!text-xxs !-top-5.5 !text-customGray-text'"> {{$root.translateString('date')}} *</label>
                </div>
            </span>
            <span v-if="validation.date.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.date.message }}
            </span>
        </span>

        <span class="relative w-full block col-span-2 lg:col-span-1">
            <span class="w-full flex flex-col relative text-black">
                <input @focus="validation.adults.state = null" name="adults" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="number" v-model="form.adults" />
                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{$root.translateString('participants')}}*</label>
            </span>
            <span v-if="validation.adults.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.adults.message }}
            </span>
        </span>

        <!-- <span class="relative w-full block col-span-2 lg:col-span-1">
            <span class="w-full flex flex-col relative text-black">
                <input @focus="validation.kids.state = null"  name="kids" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="number" v-model="form.kids" />
                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{$root.translateString('kids')}}*</label>
            </span>
            <span v-if="validation.kids.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.fullname.message }}
            </span>
        </span> -->

        <span class="relative w-full block col-span-2">
            <span class="w-full flex flex-col relative text-black">
                <textarea @focus="validation.message.state = null" name="message" rows="5" class="h-12 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer" placeholder=" " v-model="form.message"></textarea>
                <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{$root.translateString('allergies')}}</label>
            </span>
            <span v-if="validation.message.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                {{ validation.message.message }}
            </span>
        </span>

        <span class="flex flex-col lg:flex-row space-y-10 lg:space-y-0 w-full justify-center items-center sm:space-x-3 col-span-2">
            <span class="flex-grow flex flex-col space-y-3">

                <span class="flex flex-grow flex-col">
                    <span class="flex items-center space-x-3">
                        <span class="h-6 w-6 relative block flex-shrink-0">
                            <input @click="validation.privacy.state = null" name="contact-privacy" id="contact-privacy" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="form.privacy">
                            <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-black"></span>
                        </span>
                        <label for="contact-privacy" class="cursor-pointer text-xs sm:text-sm xl:text-xs">
                            <span class="text-black/50">
                                {{$root.translateString('accept')}}
                            </span>
                            <a class="underline text-black/50 hover:text-black/100 transition-all" :href="'/' + lang + '/privacy-policy'">
                                {{$root.translateString('link')}}
                            </a>
                        </label>
                    </span>
                    <span v-if="validation.privacy.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                        {{ validation.privacy.message }}
                    </span>
                </span>

                <!-- <span class="flex items-center space-x-3">
                    <span class="h-6 w-6 relative block flex-shrink-0">
                        <input name="marketing" id="marketing" class="absolute top-0 left-0 w-full h-full opacity-0 accent-transparent outline-none ring-0" type="checkbox" v-model="form.marketing">
                        <span class="fake-checkbox absolute top-0 left-0 w-full h-full pointer-events-none bg-no-repeat bg-center border border-black"></span>
                    </span>
                    <label for="marketing" class="cursor-pointer">
                        <span class="text-black/50 block text-xs sm:text-sm xl:text-xs !leading-none">
                            {{$root.translateString('marketing')}}
                        </span>
                    </label>
                </span> -->

            </span>

            <span class="flex w-full lg:w-auto">
                <button v-if="!loading" @click="checkForm" role="open-side-popup" type="button" class="relative w-full lg:w-auto lg:px-24 py-5 flex items-center bg-customGray-background transition-all !duration-500 mx-auto group xl:hover:!rounded-lg">
                    <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                    <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                    <span class="-top-5.5 text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                        {{$root.translateString('send')}}
                    </span>
                </button>
                <svg class="h-[30px] w-[30px] text-primary" v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                </svg>
            </span>
        </span>
    </form>

</template>

<script>

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import 'vue2-datepicker/locale/it';
    import 'vue2-datepicker/locale/en';

    export default {

        components: {
            DatePicker
        },

        props: ['lang'],

        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                error: false,
                sending: false,
                validator: null,
                showPlaceholderDate: true,
                showPlaceholderBirthDate: false,
                loading: false,
                selectedVisit: '',
                majorDate: null,
                form: {
                    visit: '',
                    date: null,
                    fullname: '',
                    email: '',
                    phone: '',
                    adults: 2,
                    //kids: '',
                    birth_date: null,
                    message: '',
                    marketing: false,
                    privacy: false
                },
                validation: {
                    date: {
                        state: null,
                        message: '',
                    },
                    fullname: {
                        state: null,
                        message: '',
                    },
                    email: {
                        state: null,
                        message: '',
                    },
                    phone: {
                        state: null,
                        message: '',
                    },
                    adults: {
                        state: null,
                        message: '',
                    },
                    kids: {
                        state: null,
                        message: '',
                    },
                    birth_date: {
                        state: null,
                        message: '',
                    },
                    message: {
                        state: null,
                        message: '',
                    },
                    privacy: {
                        state: null,
                        message: '',
                    },
                },
            }
        },

        created() {
            const subtractFromDate = (
                date,
                { years, days, hours, minutes, seconds, milliseconds } = {}
            ) => {
                const millisecondsOffset = milliseconds ?? 0
                const secondsOffset = seconds ? 1000 * seconds : 0
                const minutesOffset = minutes ? 1000 * 60 * minutes : 0
                const hoursOffset = hours ? 1000 * 60 * 60 * hours : 0
                const daysOffset = days ? 1000 * 60 * 60 * 24 * days : 0
                const dateOffset =
                    millisecondsOffset +
                    secondsOffset +
                    minutesOffset +
                    hoursOffset +
                    daysOffset

                let newDate = date
                if (years) newDate = date.setFullYear(date.getFullYear() - years)
                newDate = new Date(newDate - dateOffset)

                return newDate
            }

            this.majorDate = subtractFromDate(new Date(), { years: 18 })
            this.form.birth_date = this.convertDate(this.majorDate)
        },

        mounted() {

            window.addEventListener('message', (event) => {
                if(event.data.type === 'selectVisit'){
                    this.form.visit = event.data.content
                }
                if(event.data.type === 'emptyForm'){
                    this.resetForm()
                }
            }, false)

            /* */

        },

        methods: {

            handleBlur() {
                setTimeout(
                    () => {
                        if(this.form.date == null) {
                            this.showPlaceholderDate = true
                        }else{
                            this.showPlaceholderDate = false
                        }
                    }, 300
                )

            },

            convertDate(inputFormat) {
                function pad(s) { return (s < 10) ? '0' + s : s; }
                var d = new Date(inputFormat)
                return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('/')
            },

            disabledDate(date) {
                return date < new Date();
            },

            disabledDateBirthDate(date) {
                return date > Date.parse(this.majorDate);
            },

            resetForm() {
                this.form = {
                    visit: '',
                    date: null,
                    fullname: '',
                    email: '',
                    phone: '',
                    adults: 2,
                    //kids: '',
                    birth_date: null,
                    message: '',
                    privacy: false
                }
                this.showPlaceholderDate = true
                this.showPlaceholderBirthDate = true
            },

            checkForm() {

                this.sending = true;
                let error = false;

                //if(this.form.kids == '') this.form.kids = 0

                Object.keys(this.validation).forEach(key => {
                    this.validation[key].state = null;
                });

                if(this.form.date == null) {
                    this.validation.date.message = this.$root.translateString('form-mandatory');
                    this.validation.date.state = false;
                    error = true;
                }

                if(this.form.fullname == '') {
                    this.validation.fullname.message = this.$root.translateString('form-mandatory');
                    this.validation.fullname.state = false;
                    error = true;
                }

                if(this.form.email == '') {
                    this.validation.email.message = this.$root.translateString('form-mandatory');
                    this.validation.email.state = false;
                    error = true;
                }

                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) {
                    this.validation.email.message = this.$root.translateString('form-format');
                    this.validation.email.state = false;
                    error = true;
                }

                /*if(this.form.country == '') {
                    this.validation.country.message = this.$root.translateString('form-mandatory');
                    this.validation.country.state = false;
                    error = true;
                }*/

                if(this.form.phone == '' || ( this.form.phone != '' && !(/^[+()\d-]+$/.test(this.form.phone)) ) ) {
                    this.validation.phone.message = this.$root.translateString('form-format');
                    this.validation.phone.state = false;
                    error = true;
                }

                if(this.form.adults == '') {
                    this.validation.message.adults = this.$root.translateString('form-mandatory');
                    this.validation.message.state = false;
                    error = true;
                }

                if(this.form.message == '') {
                    this.validation.message.message = this.$root.translateString('form-mandatory');
                    this.validation.message.state = false;
                    error = true;
                }

                if(this.form.privacy === false) {
                    this.validation.privacy.message = this.$root.translateString('form-mandatory');
                    this.validation.privacy.state = false;
                    error = true;
                }

                if(!error) {
                    this.loading = true
                    this.validator = '64Tg6Jhx!z_'
                    this.sendMail()
                }else{
                    this.sending = false;
                }

            },

            sendMail() {
                if(this.validator == '64Tg6Jhx!z_') {

                    setTimeout(() => {
                        document.querySelector('#visit-form').submit()
                    }, 500);

                }else{

                    return false

                }
            }

        }
    }
</script>

<style>

    .mx-datepicker{
        width:100%;
        display: inline-flex;
    }

    .mx-input-wrapper{
        display: inline-flex;
        width: 100%;
    }

    .mx-input-wrapper .mx-input{
        width: 100%;
        height: 100%;
        padding: 0 !important;
        padding-left: 10px;
        font-size: inherit;
        text-align: center;
        line-height: 1.4;
        color: inherit;
        background-color: transparent;
        border: 0;
        border-radius: 0;
    }

    .mx-icon-calendar, .mx-icon-clear{
        display:none !important
    }

    .mx-datepicker-main{
        color: #ffffff !important;
        background-color: #000 !important;
        border: 1px solid #ffffff !important;
    }

    .mx-datepicker-popup{
        margin-top: -1px !important;
    }

    .mx-btn, .mx-table-date td, .mx-table-date th{
        color: #ffffff !important;
        font-size: .9rem !important;
        text-transform: uppercase !important;
    }

    .mx-calendar{
        width: 340px !important;
        padding: 6px 6px !important;

    }

    .mx-calendar-header{
        padding: 0px 12px !important;
    }

    .mx-calendar-content .cell {
        text-transform: uppercase !important;
    }

    .mx-calendar-content .cell:hover {
        background-color: #b5945b;
        transition:all 200ms;
        color: #ffffff;
    }

    .mx-calendar-content .cell.active {
        color: #ffffff;
        background-color: #9f7f49;
        transition:all 200ms;
    }

    .mx-datepicker-popup{
        left: 50% !important;
        transform: translateX(-50%);
    }

    .mx-calendar-content .cell.disabled{
        background-color: transparent;
        opacity: .5;
    }

</style>
